import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import PaymentInfo from "@/pages/checkout/components/PaymentInfo/PaymentInfo";
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
import stl from "./PaymentSuccess.module.css";
import useHelpers from "@hooks/useHelpers";
import NeedHelp from "@/_MiniApps/NeedHelp/NeedHelp";
import useIsWebView from "@hooks/useIsWebview";
import useWebview from "@hooks/useWebview";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import useBoolean from "@hooks/useBoolean";
var PaymentSuccess = function PaymentSuccess(_ref) {
  var checkoutOrder = _ref.checkoutOrder;
  var _useTranslation = useTranslation(["web_checkout_cash"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateToHard = _useHelpers.navigateToHard;
  var isWebView = useIsWebView();
  var webview = useWebview();
  var _useState = useState(false),
    showCarInfo = _useState[0],
    setShowCarInfo = _useState[1];
  var grantedPopup = useBoolean();
  var toggleCarInfo = function toggleCarInfo() {
    return setShowCarInfo(!showCarInfo);
  };
  var handleHomeNavigation = function handleHomeNavigation() {
    webview.openScreen("home", {})["catch"](function () {
      if (isWebView) {
        return webview.closeScreen()["catch"](function () {
          return document.location.href = "app://close";
        });
      }
      navigateToHard("/");
    });
  };
  var handleTrackingNavigation = function handleTrackingNavigation() {
    webview.openScreen("tracking_order", {})["catch"](function () {
      navigateToHard("/tracking-checkout-details/".concat(checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.id));
    });
  };

  // Choose the appropriate message based on order details
  var getSuccessMessage = function getSuccessMessage() {
    if (checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.can_examine && checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.examine_details) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: ["m-show", "TDCaseA", stl.normalWight].join(" ")
      }, t("sales_representative_contact_within_24", {
        ns: "web_checkout_cash"
      })), /*#__PURE__*/React.createElement("span", {
        className: ["m-show", "TDCaseB", stl.normalWight].join(" ")
      }, "\u0633\u064A\u0642\u0648\u0645 \u0645\u0648\u0638\u0641 \u0627\u0644\u0645\u0628\u064A\u0639\u0627\u062A \u0628\u0627\u0644\u062A\u0648\u0627\u0635\u0644 \u0645\u0639\u0643 \u062E\u0644\u0627\u0644 24 \u0633\u0627\u0639\u0629 \u0644\u0625\u062A\u0645\u0627\u0645 \u0639\u0645\u0644\u064A\u0629 \u0627\u0644\u0634\u0631\u0627\u0621 \u0648\u062A\u062D\u062F\u064A\u062F \u0645\u0648\u0639\u062F \u0645\u0639\u0627\u064A\u0646\u0629 \u0627\u0644\u0633\u064A\u0627\u0631\u0629 \u0641\u064A \u0645\u0648\u0642\u0639\u0646\u0627 \u0628\u0627\u0644\u0631\u064A\u0627\u0636"), /*#__PURE__*/React.createElement("span", {
        className: "m-hide"
      }, t("sales_agent_contact_within_24", {
        ns: "web_checkout_cash"
      })));
    }
    if (checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.limited_quantity) {
      return /*#__PURE__*/React.createElement("span", null, t("team_work_providing_car_contacting", {
        ns: "web_checkout_cash"
      }));
    }
    return /*#__PURE__*/React.createElement("span", null, t("sales_agent_contact_within_24", {
      ns: "web_checkout_cash"
    }));
  };
  var getToggleDetailsText = function getToggleDetailsText() {
    if (showCarInfo) {
      return t("hide_details", {
        ns: "web_checkout_cash"
      });
    }
    return t("view_details", {
      ns: "web_checkout_cash"
    });
  };
  var renderCarDetails = function renderCarDetails() {
    if (!checkoutOrder) {
      return /*#__PURE__*/React.createElement("div", {
        className: stl.loadingContainer
      }, /*#__PURE__*/React.createElement(BoxLoading, {
        divHeight: 80,
        className: "mb-2"
      }), /*#__PURE__*/React.createElement(BoxLoading, {
        divHeight: 30,
        className: "mb-2"
      }), /*#__PURE__*/React.createElement(BoxLoading, {
        divHeight: 30,
        className: "mb-2"
      }), /*#__PURE__*/React.createElement(BoxLoading, {
        divHeight: 40,
        className: "mb-2"
      }));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: stl.carInfo
    }, renderCarContent(), /*#__PURE__*/React.createElement("div", {
      className: stl.showMoreDet,
      onClick: toggleCarInfo
    }, getToggleDetailsText()));
  };
  var renderCarContent = function renderCarContent() {
    if (showCarInfo) {
      return /*#__PURE__*/React.createElement("div", {
        className: stl.infoChanges
      }, /*#__PURE__*/React.createElement(PaymentInfo, {
        loading: false,
        checkoutOrder: checkoutOrder,
        onClickInfoIcon: grantedPopup.setTrue
      }));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: stl.topSection
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
      src: checkoutOrder.post_image,
      alt: checkoutOrder.post_title
    })), /*#__PURE__*/React.createElement("strong", null, checkoutOrder.post_title)), /*#__PURE__*/React.createElement("div", {
      className: stl.sec
    }, /*#__PURE__*/React.createElement("strong", {
      className: stl.label
    }, t("order", {
      ns: "web_checkout_cash"
    })), /*#__PURE__*/React.createElement("strong", {
      id: "payment-success_order-id",
      className: stl.orderId
    }, checkoutOrder.id)), /*#__PURE__*/React.createElement("div", {
      className: stl.sec
    }, /*#__PURE__*/React.createElement("strong", {
      className: stl.label
    }, t("remaining_amount", {
      ns: "web_checkout_cash"
    })), /*#__PURE__*/React.createElement("strong", {
      className: stl.price
    }, checkoutOrder.remaining_price, /*#__PURE__*/React.createElement("span", null, t("sar", {
      ns: "web_checkout_cash"
    })))));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.alert
  }, /*#__PURE__*/React.createElement("img", {
    src: "".concat(CDN_LINK, "/assets/images/check-filled.svg"),
    alt: ""
  }), /*#__PURE__*/React.createElement("strong", null, t("down_payment_paid_successfully", {
    ns: "web_checkout_cash"
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.borderBottom
  }, /*#__PURE__*/React.createElement("div", {
    className: ["container", stl.container].join(" ")
  }, /*#__PURE__*/React.createElement("img", {
    src: "".concat(CDN_LINK, "/assets/images/check-payment.svg"),
    alt: "Success"
  }), /*#__PURE__*/React.createElement("strong", null, t("thank", {
    ns: "web_checkout_cash"
  })), getSuccessMessage(), renderCarDetails(), /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.btnsWrapper, " flex-wrap")
  }, /*#__PURE__*/React.createElement("button", {
    className: [stl.btn, stl.blueBorder, '!border-none', 'cursor-pointer', 'min-w-full', 'whtBtn'].join(" "),
    onClick: handleHomeNavigation
  }, t("back_homepge", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("button", {
    className: [stl.btn, stl.blueBtn, '!border-none', 'cursor-pointer', 'min-w-full'].join(" "),
    onClick: handleTrackingNavigation
  }, t("track_car_order", {
    ns: "web_checkout_cash"
  }))))), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: grantedPopup.value,
    onClose: grantedPopup.setFalse,
    containerClassName: "!z-[999999999]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center gap-8 p-[13px]"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/infoOrange.svg",
    width: "96px",
    height: "82px",
    alt: "icon"
  }), /*#__PURE__*/React.createElement("strong", {
    className: "text-[#3C56D4] text-center text-[32px] font-bold leading-[32px]"
  }, t("shipping_cost_2", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[#3C56D4] text-center font-[Cairo] text-[20px] font-semibold leading-[32px]"
  }, t("shipping_cost_determined_sales_representative", {
    ns: "web_checkout_cash"
  })))), /*#__PURE__*/React.createElement(NeedHelp, {
    page: "PaymentSuccess",
    post_id: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_id
  }));
};
export default PaymentSuccess;